import React from 'react';
import "./error.css"

export default function NoMatch() {
    return (
        <div className="react-error-container">
            <div>
                <p>
                    Sorry, we couldn't find a match for that.
                </p>
            </div>

            <div style={{marginTop: "1.5rem"}}>
                <p>Can't find what you're looking for?</p>
                <a href="https://go2.striim.com/demo">Schedule a call with a Striim team member here</a>
            </div>
        </div>
    )
}
